import React, { useState } from 'react';

import DisclaimerIcon from './SvgIcon/DisclaimerIcon';
import NeedHelpIcon from './SvgIcon/NeedHelpIcon';
// import HomeIndicator from './SvgIcon/HomeIndicator';

import ModalFooter from './ModalFooter';
import ModalDisclaimer from './ModalDisclaimer';
import MobileButton from './Button';
import InclaimationIcon from './SvgIcon/InclaimationIcon';
import ModalHelp from './ModalHelp';
import QuestionIcon from './SvgIcon/QuestionIcon';

export default function MobileFooter({
	onClick = () => {},
	hasBack = true,
	textButtonBack = 'BACK',
	textButtonContinue = 'CONTINUE',
	hasNext = false,
	onSubmit = () => {},
	disabled = false,
	className = '',
	loading = false,
	htmlType = '',
	hideContinueBtn = false,
	disclaimer = true
}) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [typeModal, setTypeModal] = useState('');

	return (
		<div className={`main-profile-footer ${className}`}>
			{hasNext && !hideContinueBtn ? (
				<div className="hasNext">
					<MobileButton text={textButtonBack} onClick={onClick} />{' '}
					<MobileButton
						htmlType={htmlType}
						loading={loading}
						text={textButtonContinue}
						className="btn-green"
						disabled={disabled}
						onClick={onSubmit}
					/>
				</div>
			) : hasBack ? (
				<MobileButton onClick={onClick} />
			) : null}

			{disclaimer && (
				<div className="profile-footer-icons-container">
					<DisclaimerIcon
						onClick={() => {
							setTypeModal('disclaimer');
							setIsModalOpen(prev => !prev);
						}}
					/>
					<NeedHelpIcon
						onClick={() => {
							setTypeModal('needhelp');
							setIsModalOpen(prev => !prev);
						}}
					/>
				</div>
			)}

			<ModalFooter
				open={isModalOpen}
				typeModal={typeModal}
				content={
					typeModal === 'disclaimer' ? (
						<ModalDisclaimer icon={<InclaimationIcon />} />
					) : (
						<ModalHelp email="contact@lendami.com.ph" number="+639176544580" icon={<QuestionIcon />} />
					)
				}
				setIsModalOpen={setIsModalOpen}
			/>
		</div>
	);
}
